/* eslint-disable indent */

import React, { ReactNode, useEffect } from 'react';
import { IEpModalButtonList } from '../../interfaces';
// import { Modal } from 'bootstrap';
import { EpButton } from '../EpButton';
import { EpIcon } from '../EpIcon';

import './EpModal.scss';

interface EpModalProps {
  modalId: string;
  modalTitle: string;
  modalHeaderTitleIconName?: string;
  modalType: 'default' | 'danger';
  modalSize?: 'sm' | 'md' | 'lg' | 'xl';
  modalButtonList?: IEpModalButtonList[];
  modalFooter?: boolean | null | undefined;
  modalHeader?: boolean;
  ModalPreventBackdropClose?: boolean;
  customClasses?: string;
  children: ReactNode;
  hasCloseBtn?: boolean;
}

export const showModal = (modalId: string): void => {
  console.info(`🚀 ~ modalId:`, modalId);
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { Modal } = require('bootstrap');

  const modalElement: Element = document.getElementById(modalId) as Element;

  if (!modalElement) return;

  const modalInstance = Modal.getOrCreateInstance(modalElement);

  modalInstance?.show();
};

export const hideModal = (modalId: string): void => {
  console.log('hideModal');

  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { Modal } = require('bootstrap');

  const modalElement: Element = document.getElementById(modalId) as Element;

  setTimeout(() => {
    document.body.style.overflow = 'auto';
  }, 1200);

  if (!modalElement) return;

  const modalInstance = Modal?.getOrCreateInstance(modalElement);

  modalInstance?.hide();
};

export const toggleModalVisibility = (modalId: string): void => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { Modal } = require('bootstrap');

  const modalElement: Element = document.getElementById(modalId) as Element;

  if (!modalElement) return;

  const modalInstance = Modal?.getOrCreateInstance(modalElement);

  modalInstance?.toggle();
};

export const EpModal: React.FC<EpModalProps> = ({
  modalId,
  modalTitle,
  modalHeaderTitleIconName = '',
  modalType,
  modalSize = 'md',
  modalButtonList = [],
  customClasses,
  modalFooter = true,
  modalHeader = true,
  ModalPreventBackdropClose = false,
  children,
  hasCloseBtn = true,
}) => {
  const buttonListLastIndex: number = modalButtonList.length - 1;
  const buttonListLastItem: IEpModalButtonList = modalButtonList[
    buttonListLastIndex
  ] as IEpModalButtonList;

  const selectTheCorrectModalSize = (): 'sm' | 'md' | 'lg' | 'xl' => {
    switch (modalType) {
      case 'danger':
        return 'md';
      default:
        return modalSize;
    }
  };

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require('bootstrap');

    return () => {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const { Modal } = require('bootstrap');

      const modalElement = document.getElementById(modalId);
      if (modalElement) {
        const modalInstance = Modal.getInstance(modalElement);
        if (modalInstance) {
          modalInstance.hide();
          modalInstance.dispose();
        }
      }
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) backdrop.remove();
    };
  }, [modalId]);

  const renderButtonList = () => {
    if (modalSize === 'lg' || modalSize === 'xl') {
      return (
        modalButtonList &&
        modalButtonList.map((item: IEpModalButtonList, index: number) => {
          const isClosedButtonFormatted = item.isCloseButton || false;
          const isLastItemInParsedButtonList =
            buttonListLastItem.buttonId === item.buttonId;

          if (!isClosedButtonFormatted) {
            return (
              <li
                key={index}
                className={`ep-modal__content-header-button-list-item ${isLastItemInParsedButtonList &&
                  'ep-modal__content-header-button-list-item--second-to-last'
                  }`}
              >
                <EpButton
                  buttonId={`${item.buttonId}--header`}
                  buttonType={item.buttonType}
                  buttonSize="sm"
                  buttonLeftIconName={item.buttonLeftIconName}
                  buttonOnClickFunc={item.buttonOnClickFunc as () => void}
                  className={item?.customClasses ?? ''}
                ></EpButton>
              </li>
            );
          }

          return null;
        })
      );
    }

    return null;
  };

  return (
    <div
      id={modalId}
      className={`
        modal
        ep-modal
        ep-modal--${modalType}
        ep-modal--${selectTheCorrectModalSize()}
        ${customClasses ? customClasses : ''}
        fade
      `}
      tabIndex={-1}
      aria-labelledby={`Modal #${modalId}`}
      {...(ModalPreventBackdropClose && { 'data-bs-backdrop': 'static' })}
    >
      <div className="modal-dialog ep-modal__dialog">
        <div className={`modal-content ep-modal__content`}>
          {modalHeader && (
            <div className="ep-modal__content-header">
              <div className="ep-modal__content-header-block">
                <div className="ep-modal__content-header-icon">
                  {modalHeaderTitleIconName && (
                    <EpIcon iconName={modalHeaderTitleIconName} iconSize={16} />
                  )}
                </div>
                <h3 className="ep-modal__content-header-title">{modalTitle}</h3>
              </div>
              <ul className="ep-modal__content-header-button-list">
                {renderButtonList()}
                {hasCloseBtn && (
                  <li className="ep-modal__content-header-button-list-item ep-modal__content-header-button-list-item--close-btn">
                    <EpButton
                      buttonId={`${modalId}__close-button`}
                      buttonType="link-secondary"
                      buttonSize="sm"
                      buttonLeftIconName="SolidTimes"
                      buttonDataBsDismiss="modal"
                      buttonAriaLabel="Close"
                      buttonOnClickFunc={() => hideModal(modalId)}
                    ></EpButton>
                  </li>
                )}
              </ul>
            </div>
          )}
          <div className="ep-modal__content-body">{children}</div>
          {modalFooter && (
            <div className="ep-modal__content-footer">
              <ul
                className={`ep-modal__content-footer-button-list ${modalButtonList && modalButtonList.length === 1
                    ? 'ep-modal__content-footer-button-list--single-button'
                    : ''
                  }`}
              >
                {modalButtonList &&
                  modalButtonList.map(
                    (item: IEpModalButtonList, index: number) => (
                      <li
                        key={index}
                        className="ep-modal__content-footer-button-list-item"
                      >
                        {item.isCloseButton ? (
                          <EpButton
                            buttonId={`${item.buttonId}--footer`}
                            buttonType={item.buttonType}
                            buttonSize={
                              selectTheCorrectModalSize() === 'sm' ? 'sm' : 'md'
                            }
                            buttonText={item.buttonText}
                            buttonLeftIconName="SolidTimes"
                            buttonDataBsDismiss="modal"
                            buttonAriaLabel="Close"
                            buttonOnClickFunc={() => console.log()}
                          ></EpButton>
                        ) : (
                          <EpButton
                            buttonId={`${item.buttonId}--footer`}
                            buttonType={item.buttonType}
                            buttonSize={
                              selectTheCorrectModalSize() === 'sm' ? 'sm' : 'md'
                            }
                            buttonText={item.buttonText}
                            buttonLeftIconName={item.buttonLeftIconName}
                            buttonOnClickFunc={
                              item.buttonOnClickFunc as () => void
                            }
                          ></EpButton>
                        )}
                      </li>
                    ),
                  )}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
